import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import History from "../../assets/icons/History.svg";
import Search from "../../assets/images/mirror-search-image.png";
import MapComponent from "../Maps/MapComponent";
import { useLocation } from "react-router-dom";
import PolygonMapComponent from "../Maps/PolygonMapComponent";
import { getUserIdFromToken } from "../../auth/authUtils"
import PolygonBlockMap from "../Maps/PolygonBlockMap";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import MapIcon from '../../assets/icons/Maps.svg'
import GridIcon from '../../assets/icons/Grid.svg'
import LocationIcon from '../../assets/icons/Newmap.svg';
import FavouriteFalse from "../../assets/icons/favouritefalse.svg";
import FavouriteTrue from "../../assets/icons/favouritetrue.svg";
import OfficeIcon from '../../assets/icons/OfficeList.svg'
import OtherIcon from '../../assets/icons/OtherList.svg'
import HomeIcon from '../../assets/icons/HomeLIst.svg'
import CheckIcon from "../../assets/icons/checked.svg";
import CopyIcon from "../../assets/icons/copy.svg";
import ReactLoading from 'react-loading';
import Header from "../Header/Header";
import { getUserProfile, UserProfile } from "../../API/UserProfileApi/GetUserProfile";
import { AddtoFavouritesAsync } from "../../API/AddressFavourites/AddToFavouritesAsync";
import { RemoveFromFavouritesAsync } from "../../API/AddressFavourites/RemoveFromFavouritesAsync";
import { fetchAddressResultsAsync, fetchGlobalAddressesAsync } from "../../API/Address/SearchAddressAsync";
import { Address } from "../../API/Address/ViewAllAddedAddressByUserAsync";
import MapRecenter from "../Maps/MapRecenter";
import { updateLocalStorageSearchHistory } from "../../utils/updateLocalStorageSearchHistory";
import ReactGA from "react-ga4";
import { useLocalization } from "../Context/MultiLanguageContext";
import MapDigipin from "../Maps/MapDigipin";

interface PamCodeSuggestion {
  pamCode: string;
}


interface BoundaryData {
  latitude: number;
  longitude: number;
}
interface SearchHistoryItem {
  query: string;
  results: any;
  outsideBlock?: boolean;
}

const Home: React.FC<{ updateUserName: (newUserName: string) => void }> = ({ updateUserName }) => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const [searchData, setSearchData] = useState<string>('');
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [addresses, setAddresses] = useState<any[]>([]);
  const [showResults, setShowResults] = useState(false);
  const [viewAsGrid, setViewAsGrid] = useState(true);
  const [addressResults, setAddressResults] = useState<Address[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isPolygonView, setIsPolygonView] = useState(false);
  const [isPolygonBlockView, setIsPolygonBlockView] = useState(false);
  const [boundaryData, setBoundaryData] = useState<BoundaryData[] | BoundaryData[][]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [userName, setUserName] = useState('');
  const validAddresses = addressResults.filter(address => address.addressLine1 !== null);
  const [loading, setLoading] = useState(false);
  const [recentSearchHistory, setRecentSearchHistory] = useState<SearchHistoryItem[]>([]);
  const [copiedField, setCopiedField] = useState<{ type: "pamCode" | "digiPin"; value: string } | null>(null);
  const year = new Date().getFullYear();
  const searchContainerRef = useRef<HTMLDivElement>(null);
  const placeSuggestionTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const placeSuggestionAbortRef = useRef<AbortController | null>(null);
  const placeSuggestionCacheRef = useRef<Record<string, any[]>>({});
  const [placeSuggestions, setPlaceSuggestions] = useState<any[]>([]);
  const [selectedPlace, setSelectedPlace] = useState<string>('');

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target as Node)) {
        setSuggestions([]);
        setPlaceSuggestions([]);
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);


  const getStoredSearchHistory = (): SearchHistoryItem[] => {
    const token = localStorage.getItem('token');
    if (token) {
      const userId = getUserIdFromToken();
      const storedHistory = localStorage.getItem(`recentSearch_${userId}`);
      if (storedHistory) {
        try {
          return JSON.parse(storedHistory) as SearchHistoryItem[];
        } catch (error) {
          // console.error("Error parsing recent search history", error);
          return [];
        }
      }
    }
    return [];
  };


  const saveAllSearchQueries = (query: string) => {
    let allQueries: string[] = [];
    const stored = localStorage.getItem('allSearchQueries');

    if (stored) {
      try {
        allQueries = JSON.parse(stored);
      } catch (e) {
        allQueries = [];
      }
    }

    // Allow queries with hyphen at index 3 or no hyphens
    if (!allQueries.includes(query) && (query[3] !== '-' || query.length !== 10 || query[7] !== '-')) {
      allQueries.push(query);
      localStorage.setItem('allSearchQueries', JSON.stringify(allQueries));
    }
  };

  const saveSearchHistory = (query: string, results: any, outsideBlock?: boolean) => {
    const token = localStorage.getItem('token');
    if (token) {
      const userId = getUserIdFromToken();
      let history: SearchHistoryItem[] = getStoredSearchHistory();

      const existingItem = history.find(item => item.query === query);

      history = history.filter(item => item.query !== query);

      const outsideBlockFlag = existingItem ? existingItem.outsideBlock : false;

      history.unshift({ query, results, outsideBlock: outsideBlockFlag });

      if (history.length > 1000) {
        history = history.slice(0, 1000);
      }

      localStorage.setItem(`recentSearch_${userId}`, JSON.stringify(history));
      setRecentSearchHistory(history);
    }
    saveAllSearchQueries(query);
  };




  const handleSearchFocus = () => {
    const stored = localStorage.getItem('allSearchQueries');
    let allQueries: string[] = [];
    if (stored) {
      try {
        allQueries = JSON.parse(stored);
      } catch (e) {
        allQueries = [];
      }
    }
    const recentHistory = allQueries.slice(-5).reverse(); // Show last 5, most recent first
    const historySuggestions = recentHistory.map(query => ({ type: 'history', query }));
    setSuggestions(historySuggestions);
    ReactGA.event({
      category: "Home",
      action: "Search Focused",
    });
  };

  const handleRecentSearchClick = async (query: string) => {
    ReactGA.event({
      category: "Home",
      action: "Recent Search Clicked",
      label: query,
    });
    const normalizedQuery = query.replace(/[\s-]/g, '');
    setSearchData(formatPamCode(query));

    const history = getStoredSearchHistory();
    const selected = history.find(
      item =>
        item.query === query ||
        item.query.replace(/-/g, '') === normalizedQuery ||
        item.query === normalizedQuery ||
        item.query.replace(/-/g, '') === query.replace(/-/g, '')
    );

    if (!selected) {
      await fetchAddressResults(normalizedQuery);
      setSuggestions([]);
      return;
    }

    const results = selected.results?.addresses ? selected.results.addresses : selected.results;
    const hasNoResults =
      !results ||
      (Array.isArray(results) && results.length === 0);

    if (hasNoResults) {
      toast.error(t("noResults"), { toastId: "no-results" });
      return;
    }
    if (selected.outsideBlock) {
      if (!toast.isActive("outside-block")) {
        toast.info(t("addressOutsideBlock"), { toastId: "outside-block" });
      }
    }

    const isDigipinQuery = /^[A-Z0-9]{3}-[A-Z0-9]{3}-[A-Z0-9]{4}$/i.test(query);
    const directNavigationAddress = Array.isArray(selected.results)
      ? selected.results[0]
      : selected.results?.addresses?.[0];

    if (/^\d{11,}$/.test(normalizedQuery) && directNavigationAddress && !isDigipinQuery) {
      ReactGA.event({
        category: "Home",
        action: "Direct Navigation Recent Search",
        label: normalizedQuery,
      });
      navigate(`/search-address-details/${directNavigationAddress.id}`, { state: { address: directNavigationAddress } });
      return;
    }

    if (isDigipinQuery && Array.isArray(results)) {
      setIsPolygonView(false);
      setIsPolygonBlockView(false);
      setViewAsGrid(false);
      setAddressResults(results);
      setBoundaryData(results);
      setShowResults(true);
      setSuggestions([]);
      return;
    }

    const isBlockResult =
      selected.results &&
      typeof selected.results === 'object' &&
      Array.isArray(selected.results.addresses) &&
      Array.isArray(selected.results.boundaryData);

    const isPolygonResult =
      Array.isArray(selected.results) &&
      selected.results.length > 0 &&
      selected.results.every(
        (item: any) =>
          item.latitude !== undefined &&
          item.longitude !== undefined &&
          item.addressLine1 === undefined
      );

    const isMultiPolygonResult =
      Array.isArray(selected.results) &&
      selected.results.length > 0 &&
      selected.results.every(
        (ring: any) =>
          Array.isArray(ring) &&
          ring.length > 0 &&
          ring.every(
            (point: any) =>
              point.latitude !== undefined && point.longitude !== undefined
          )
      );

    if (isBlockResult) {
      setIsPolygonView(false);
      setIsPolygonBlockView(true);
      setViewAsGrid(false);
      setAddressResults(selected.results.addresses);
      setBoundaryData(selected.results.boundaryData || []);
    } else if (isPolygonResult) {
      setIsPolygonView(true);
      setIsPolygonBlockView(false);
      setViewAsGrid(false);
      setAddressResults(selected.results);
      setBoundaryData(selected.results);
    } else if (isMultiPolygonResult) {
      setIsPolygonView(true);
      setIsPolygonBlockView(false);
      setViewAsGrid(false);
      setAddressResults([]);
      setBoundaryData(selected.results);
    } else {
      if (/^\d{10}$/.test(normalizedQuery)) {
        setIsPolygonView(false);
        setIsPolygonBlockView(true);
      } else if (/^\d{6}$/.test(normalizedQuery)) {
        setIsPolygonView(true);
        setIsPolygonBlockView(false);
      } else {
        setIsPolygonView(false);
        setIsPolygonBlockView(false);
      }
      setViewAsGrid(false);

      if (selected.results?.addresses) {
        setAddressResults(selected.results.addresses);
        setBoundaryData(selected.results.boundaryData || []);
      } else {
        setAddressResults(selected.results);
        if (/^\d{6}$/.test(normalizedQuery)) {
          setBoundaryData(
            selected.results.map((address: any) => ({
              latitude: address.latitude,
              longitude: address.longitude,
            }))
          );
        }
      }
    }

    setShowResults(true);
    setSuggestions([]);
  };



  const handleAddressClickDetails = (address: Address) => {
    ReactGA.event({
      category: "Home",
      action: "Clicked Address Detail",
      label: address.pamCode || address.id,
    });
    navigate(`/search-address-details/${address.id}`, { state: { address } });
  };

  const handleCopy = async (value: string, type: "pamCode" | "digiPin") => {
    try {
      const finalValue = String(value ?? "").trim();
      await navigator.clipboard.writeText(finalValue);
      setCopiedField({ type, value: finalValue });
      setTimeout(() => setCopiedField(null), 2000);
      ReactGA.event({
        category: "Home",
        action: `${type === "pamCode" ? "PAM Code" : "DigiPin"} Copied`,
        label: finalValue,
      });
    } catch (err) {
      // ignore clipboard copy failures
    }
  };


  const fetchGlobalAddresses = async (sanitizedQuery: string): Promise<{
    addressesWithPamCode: any[];
    boundaryData?: any;
  } | null> => {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error(t("sessionExpired"));
      navigate('/');
      return null;
    }
    setLoading(true);
    try {
      const result = await fetchGlobalAddressesAsync(sanitizedQuery, token);
      const { addressesWithPamCode, boundaryData } = result;

      if (addressesWithPamCode.length === 0 && !boundaryData) {
        if (!toast.isActive("no-results")) {
          // toast.error(t("noResults"), { toastId: "no-results" });
        }
        setSuggestions([]);
        setAddresses([]);
      } else {
        if (
          searchData[3] === '-' && searchData[7] === '-' &&
          addressesWithPamCode.length === 0 && boundaryData && Object.keys(boundaryData).length > 0
        ) {
          setSuggestions([]);
          setAddresses([]);
          return result;
        }
        const suggestionsModified = addressesWithPamCode.map(item => {
          const normalized = item.pamCode.replace(/-/g, '');
          return normalized.length >= 11
            ? { ...item, directNavigation: true }
            : item;
        });
        setSuggestions(suggestionsModified);
        setAddresses(suggestionsModified);
      }
      return result;
    } catch (error) {
      // console.error('Error fetching global addresses:', error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const fetchPlaceSuggestions = async (query: string) => {
    const normalizedQuery = query.trim().toLowerCase();

    if (placeSuggestionTimerRef.current) {
      clearTimeout(placeSuggestionTimerRef.current);
    }
    placeSuggestionAbortRef.current?.abort();

    if (normalizedQuery.length < 2) {
      setPlaceSuggestions([]);
      return;
    }

    const cachedSuggestions = placeSuggestionCacheRef.current[normalizedQuery];
    if (cachedSuggestions) {
      setPlaceSuggestions(cachedSuggestions);
      return;
    }

    placeSuggestionTimerRef.current = setTimeout(async () => {
      const abortController = new AbortController();
      placeSuggestionAbortRef.current = abortController;

      try {
        const response = await fetch(
          `https://photon.komoot.io/api/?q=${encodeURIComponent(
            query.trim()
          )}&lat=10.8505&lon=76.2711&limit=5`,
          { signal: abortController.signal }
        );

        if (!response.ok) {
          throw new Error(`Place suggestions failed with status ${response.status}`);
        }

        const result = await response.json();
        const data = (result.features || []).map((feature: any) => {
          const properties = feature.properties || {};
          const displayName = [
            properties.name,
            properties.street,
            properties.city || properties.county,
            properties.state,
            properties.country,
          ]
            .filter(Boolean)
            .filter((part: string, index: number, parts: string[]) =>
              parts.indexOf(part) === index
            )
            .join(', ');

          return {
            name: properties.name || displayName,
            display_name: displayName,
            latitude: feature.geometry?.coordinates?.[1],
            longitude: feature.geometry?.coordinates?.[0],
          };
        });

        placeSuggestionCacheRef.current[normalizedQuery] = data;
        if (!abortController.signal.aborted) {
          setPlaceSuggestions(data);
        }
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') {
          return;
        }
        setPlaceSuggestions([]);
      }
    }, 1000);
  };

  const cancelPlaceSuggestions = () => {
    if (placeSuggestionTimerRef.current) {
      clearTimeout(placeSuggestionTimerRef.current);
      placeSuggestionTimerRef.current = null;
    }
    placeSuggestionAbortRef.current?.abort();
    placeSuggestionAbortRef.current = null;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^a-zA-Z0-9- ]/g, '');

    setSearchData(value);

    if (!value.trim()) {
      cancelPlaceSuggestions();
      setSuggestions([]);
      setPlaceSuggestions([]);
      setAddressResults([]);
      setBoundaryData([]);
      setShowResults(false);
      setViewAsGrid(true);
      setIsPolygonView(false);
      setIsPolygonBlockView(false);
      return;
    }

    if (
      selectedPlace &&
      !value.toLowerCase().startsWith(selectedPlace.toLowerCase())
    ) {
      setSelectedPlace('');
    }

    let normalizedValue = '';

    if (value[3] === '-' && value[7] === '-') {
      normalizedValue = value;
    } else {
      normalizedValue = value.replace(/[\s-]/g, '');
    }

    ReactGA.event({
      category: "Home",
      action: "Search Input Changed",
      label: normalizedValue,
    });

    /*
     * ---------------------------------------------------------
     * PLACE SEARCH
     * ---------------------------------------------------------
     *
     * Only start place suggestions when the user is typing
     * letters and has not yet selected a place.
     *
     * Examples:
     * k
     * ka
     * kal
     * kaloor
     */
    if (
      !selectedPlace &&
      /^[a-zA-Z ]+$/.test(value) &&
      value.length >= 1
    ) {
      fetchPlaceSuggestions(value);
    } else {
      cancelPlaceSuggestions();
      setPlaceSuggestions([]);
    }

    /*
     * ---------------------------------------------------------
     * EXISTING SEARCH HISTORY
     * ---------------------------------------------------------
     */

    const stored = localStorage.getItem('allSearchQueries');

    let allQueries: string[] = [];

    if (stored) {
      try {
        allQueries = JSON.parse(stored);
      } catch (e) {
        allQueries = [];
      }
    }

    const filteredHistory = allQueries.filter(query =>
      query.replace(/-/g, '').includes(normalizedValue)
    );

    const historySuggestions = filteredHistory.map(query => ({
      type: 'history',
      query,
    }));

    /*
     * Don't overwrite place suggestions with history suggestions
     * when user is typing a place name.
     */
    if (!/^[a-zA-Z ]+$/.test(value)) {
      setSuggestions(historySuggestions);
    } else {
      setSuggestions([]);
    }

    /*
     * ---------------------------------------------------------
     * EXISTING NUMERIC PAM SEARCH
     * ---------------------------------------------------------
     */

    if (/^\d+$/.test(normalizedValue)) {

      if (normalizedValue.length === 10) {

        const enteredPin = normalizedValue.slice(0, 6);

        fetchGlobalAddresses(normalizedValue).then((result) => {

          if (
            result &&
            result.addressesWithPamCode &&
            result.addressesWithPamCode.length > 0
          ) {

            const firstAddress = result.addressesWithPamCode[0];

            const recommendedPin = firstAddress.pbdpPinCode
              ? firstAddress.pbdpPinCode.trim()
              : '';

            if (recommendedPin && enteredPin !== recommendedPin) {

              toast.info(t("addressOutsideBlock"), {
                toastId: "outside-block-" + Date.now(),
              });

            }
          }
        });

      } else if (normalizedValue.length > 9) {

        fetchGlobalAddresses(normalizedValue);

      }
    }

    /*
     * ---------------------------------------------------------
     * PLACE + 4 DIGIT BLOCK CODE
     * ---------------------------------------------------------
     *
     * Examples:
     *
     * kaloor3456
     * kaloor-3456
     *
     * Both are sent to the existing PAM search API as:
     *
     * kaloor3456
     */

    const placeBlockMatch = normalizedValue.match(
      /^([a-zA-Z]+)(\d{4})$/
    );

    if (placeBlockMatch) {

      const placeBlockQuery = normalizedValue.toLowerCase();

      fetchGlobalAddresses(placeBlockQuery);
    }
  };

  const handlePlaceSuggestionClick = (suggestion: any) => {

    const placeName =
      suggestion.name ||
      suggestion.display_name?.split(',')[0] ||
      '';

    const cleanPlaceName = placeName.trim();

    setSelectedPlace(cleanPlaceName);
    setSearchData(cleanPlaceName);

    setPlaceSuggestions([]);
    setSuggestions([]);

    ReactGA.event({
      category: "Home",
      action: "Place Selected from Suggestions",
      label: cleanPlaceName,
    });
  };

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await handleSearchClick();
  };



  const HeartClick = async (addressId: any, isFavourite: boolean) => {
    setAddressResults((prevData) =>
      prevData.map((item) =>
        item.id === addressId ? { ...item, isFavourite: !item.isFavourite } : item
      )
    );

    const token = localStorage.getItem('token');
    if (!token) {
      // console.error('Token not found. User might be logged out.');
      return;
    }

    try {
      if (!isFavourite) {
        await AddtoFavouritesAsync(addressId, token);
        updateLocalStorageSearchHistory(addressId, true);
      } else {
        await RemoveFromFavouritesAsync(addressId, token);
        updateLocalStorageSearchHistory(addressId, false);
      }
      const userId = getUserIdFromToken();
      const storedHistory = localStorage.getItem(`recentSearch_${userId}`);
      if (storedHistory) {
        setRecentSearchHistory(JSON.parse(storedHistory));
      }

      ReactGA.event({
        category: "Home",
        action: "Toggle Favourite",
        label: `Address ID: ${addressId}, New State: ${!isFavourite}`,
      });

    } catch (error) {
      // console.error('An error occurred while updating favourite status:', error);
      revertFavouriteState(addressId, isFavourite);
    }
  };



  const revertFavouriteState = (addressId: number, originalState: boolean) => {
    setAddresses((prevData) =>
      prevData.map((item) =>
        item.id === addressId ? { ...item, isFavourite: originalState } : item
      )
    );
  };


  const handleSearchClick = async () => {
    let editedSearchData;
    if (searchData[3] === '-' && searchData[7] === '-') {
      editedSearchData = searchData;
    } else {
      editedSearchData = searchData.replace(/[\s-]/g, '');
    }

    const isDigipin = /^[A-Z0-9]{3}-[A-Z0-9]{3}-[A-Z0-9]{4}$/i.test(searchData);
    const isTextSearch = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/.test(editedSearchData);
    const isValidSearch =
      /^\d{6}$/.test(editedSearchData) ||          // Pincode
      /^\d{10}$/.test(editedSearchData) ||         // Pin + Block
      /^\d{11,}$/.test(editedSearchData) ||        // PAM Code
      isDigipin ||                                // DIGIPIN
      isTextSearch;                                // Name / label search

    if (!isValidSearch) {
      toast.info(
        "Please enter a valid Pincode, Block Code, PAM Code or DIGIPIN.",
        { toastId: "invalid-search" }
      );
      return;
    }

    ReactGA.event({
      category: "Home",
      action: "Search Button Clicked",
      label: editedSearchData,
    });

    setIsLoading(true);

    if (!editedSearchData.trim()) {
      if (!toast.isActive("no-search")) {
        toast.info(t("enterSearchTerm"), { toastId: "no-search" });
      }
      setIsLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authorization token found.");
      }


      if (editedSearchData.length >= 11 && /^\d{11,}$/.test(editedSearchData)) {
        const data = await fetchAddressResultsAsync(editedSearchData, token);


        if (data && Array.isArray(data) && data.length > 0) {
          const selectedAddress = data[0];
          saveSearchHistory(editedSearchData, { addresses: [selectedAddress] });
          ReactGA.event({
            category: "Home",
            action: "Direct Navigation 11+ digit Search",
            label: editedSearchData,
          });
          navigate(`/search-address-details/${selectedAddress.id}`, { state: { address: selectedAddress } });
        } else {
          toast.error(t("noResults"), { toastId: "no-results" });
        }
        setIsLoading(false);
        return;
      }

      // Handle other search queries
      const data = await fetchAddressResultsAsync(editedSearchData, token);

      const isDigipinResponse =
        isDigipin &&
        Array.isArray(data) &&
        data.length > 0 &&
        data.every(
          item =>
            item.latitude !== undefined &&
            item.longitude !== undefined
        );

      const isBoundaryResponse =
        Array.isArray(data) &&
        data.length > 0 &&
        data.every(
          item =>
            item.latitude !== undefined &&
            item.longitude !== undefined &&
            item.addressLine1 === undefined
        );

      const isMultiBoundaryResponse =
        Array.isArray(data) &&
        data.length > 0 &&
        data.every(
          (ring: any) =>
            Array.isArray(ring) &&
            ring.length > 0 &&
            ring.every(
              (point: any) =>
                point.latitude !== undefined && point.longitude !== undefined
            )
        );

      const isBlockResponse =
        data &&
        typeof data === "object" &&
        Array.isArray(data.addresses) &&
        Array.isArray(data.boundaryData);

      if (isDigipinResponse) {
        setIsPolygonView(false);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);

        setAddressResults(data);
        setBoundaryData(data);
        setShowResults(true);

        saveSearchHistory(editedSearchData, data);

        setSuggestions([]);
        setIsLoading(false);
        return;
      }

      if (isBoundaryResponse) {
        setIsPolygonView(true);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);

        setBoundaryData(data);
        setAddressResults([]);
        setShowResults(true);

        saveSearchHistory(editedSearchData, data);
        setSuggestions([]);
        setIsLoading(false);
        return;
      }

      if (isMultiBoundaryResponse) {
        setIsPolygonView(true);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);

        setBoundaryData(data);
        setAddressResults([]);
        setShowResults(true);

        saveSearchHistory(editedSearchData, data);
        setSuggestions([]);
        setIsLoading(false);
        return;
      }

      // Locality block search (Kaloor0001, Edappally0002, etc.)
      if (isBlockResponse) {
        setIsPolygonView(false);
        setIsPolygonBlockView(true);
        setViewAsGrid(false);

        setAddressResults(data.addresses || []);
        setBoundaryData(data.boundaryData || []);
        setShowResults(true);

        saveSearchHistory(editedSearchData, data);
        setSuggestions([]);
        setIsLoading(false);
        return;
      }

      if (/^\d{10}$/.test(editedSearchData)) {
        setIsPolygonView(false);
        setIsPolygonBlockView(true);
        setViewAsGrid(false);

        const { addresses, boundaryData } = data;
        if (addresses && addresses.length > 0) {
          const recommendedPin = addresses[0].pinCode?.toString().trim();
          const enteredPin = editedSearchData.slice(0, 6);
          if (recommendedPin && enteredPin !== recommendedPin) {
            if (!toast.isActive("outside-block")) {
              toast.info(t("addressOutsideBlock"), { toastId: "outside-block" });
            }
          }
          setAddressResults(addresses || []);
          setBoundaryData(boundaryData || []);
          setShowResults(true);
          setSuggestions([]);
          saveSearchHistory(editedSearchData, { addresses, boundaryData });
        } else {
          toast.error(t("noResults"), { toastId: "no-results" });
          setAddressResults([]);
          setBoundaryData([]);
          setShowResults(false);
        }
      } else if (/^\d{6}$/.test(editedSearchData)) {
        setIsPolygonView(true);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);

        if (data && Array.isArray(data) && data.length > 0) {
          setAddressResults(data);
          setBoundaryData(
            data.map((address: any) => ({
              latitude: address.latitude,
              longitude: address.longitude,
            }))
          );
          setShowResults(true);
          saveSearchHistory(editedSearchData, data);
        } else {
          toast.error(t("noResults"), { toastId: "no-results" });
          setAddressResults([]);
          setBoundaryData([]);
          setShowResults(false);
        }
      } else {
        setIsPolygonView(false);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);

        if (data && Array.isArray(data) && data.length > 0) {
          setAddressResults(data);
          setShowResults(true);
          saveSearchHistory(editedSearchData, data);
        } else {
          toast.error(t("noResults"), { toastId: "no-results" });
          setAddressResults([]);
          setShowResults(false);
        }
      }
    } catch (error) {
      // console.error("Error fetching addresses:", error);
      // toast.error(t("unexpectedError"), { toastId: "fetch-error" });
      setAddressResults([]);
      setBoundaryData([]);
      setShowResults(false);
    } finally {
      setIsLoading(false);
      setLoading(false);
      setSuggestions([]);
    }
  };

  const handleAddressClick = (pamCode: string, suggestion?: any) => {
    const normalizedPamCode = pamCode.replace(/[\s-]/g, '');
    const selectedAddress = addresses.find(
      (address: any) => address.pamCode.replace(/-/g, '') === normalizedPamCode
    );
    if (selectedAddress) {

      ReactGA.event({
        category: "Home",
        action: "Address Clicked from Suggestions",
        label: normalizedPamCode,
      });

      if (normalizedPamCode.length >= 11 || (suggestion && suggestion.directNavigation)) {
        saveSearchHistory(normalizedPamCode, { addresses: [selectedAddress] });
        navigate(`/search-address-details/${selectedAddress.id}`, { state: { address: selectedAddress } });
      } else {
        setSearchData(formatPamCode(pamCode));
        setSuggestions([]);
        setAddressResults([selectedAddress]);
        setShowResults(true);
        setViewAsGrid(false);
        setIsPolygonView(false);
        setIsPolygonBlockView(false);
        if (selectedAddress.latitude && selectedAddress.longitude) {
          setBoundaryData([{ latitude: selectedAddress.latitude, longitude: selectedAddress.longitude }]);
        }
        saveSearchHistory(normalizedPamCode, { addresses: [selectedAddress] });
      }
    }
  };


  const handleLocationIconClick = (latitude: number, longitude: number) => {
    ReactGA.event({
      category: "Home",
      action: "Location Icon Clicked",
      label: `Lat: ${latitude}, Lng: ${longitude}`,
    });
    const defaultMap = localStorage.getItem("defaultMap") || "google";

    if (defaultMap === "waze") {
      const wazeMapsUrl = `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes`;
      window.open(wazeMapsUrl, '_blank');
    } else if (defaultMap === "mapindia") {
      const mapplsUrl = `https://www.mappls.com/@${latitude},${longitude}`;
      window.open(mapplsUrl, "_blank");
    } else if (defaultMap === "apple") {
      const appleMapsUrl = `https://maps.apple.com/?ll=${latitude},${longitude}&q=${latitude},${longitude}&z=18&t=m`;
      window.open(appleMapsUrl, "_blank");
    } else {
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
      window.open(googleMapsUrl, '_blank');
    }
  };
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userToken');
    localStorage.removeItem('token');
    localStorage.removeItem('userName');

    // Clear all search history and queries
    localStorage.removeItem('allSearchQueries');
    const userId = getUserIdFromToken();
    if (userId) {
      localStorage.removeItem(`recentSearch_${userId}`);
    }
    setRecentSearchHistory([]);

    sessionStorage.clear();
    navigate("/", { replace: true });
  };

  const fetchAddressResults = async (searchData: string) => {
    setIsLoading(true);

    if (!searchData.trim()) {
      if (!toast.isActive("no-search")) {
        toast.info(t("enterSearchTerm"), { toastId: "no-search" });
      }
      setIsLoading(false);
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authorization token found.");
      }

      const data = await fetchAddressResultsAsync(searchData, token);

      if (/^\d{10}$/.test(searchData)) {
        setIsPolygonView(false);
        setIsPolygonBlockView(true);
        setViewAsGrid(false);

        const { addresses, boundaryData } = data;
        if (addresses && addresses.length > 0) {
          const recommendedPin = addresses[0].pinCode?.toString().trim();
          const enteredPin = searchData.slice(0, 6);
          if (recommendedPin && enteredPin !== recommendedPin) {
            if (!toast.isActive("outside-block")) {
              toast.info(t("addressOutsideBlock"), { toastId: "outside-block" });
            }
          }
        }

        const validBoundary = boundaryData !== null && boundaryData !== undefined;

        if (validBoundary) {
          setAddressResults(addresses || []);
          setBoundaryData(boundaryData);
          setShowResults(true);
          setSuggestions([]);
        } else {
          toast.error(t("noResults"), { toastId: "no-results" });
          setAddressResults([]);
          setBoundaryData([]);
          setShowResults(false);
        }
      } else if (/^\d{6}$/.test(searchData)) {
        setIsPolygonView(true);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);

        if (data && Array.isArray(data) && data.length > 0) {
          setAddressResults(data);
          setBoundaryData(
            data.map((address: any) => ({
              latitude: address.latitude,
              longitude: address.longitude,
            }))
          );
          setShowResults(true);
        } else {
          toast.error(t("noResults"), { toastId: "no-results" });
          setAddressResults([]);
          setBoundaryData([]);
          setShowResults(false);
        }
      } else {
        setIsPolygonView(false);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);

        if (data && Array.isArray(data) && data.length > 0) {
          setAddressResults(data);
          setShowResults(true);
        } else {
          toast.error(t("noResults"), { toastId: "no-results" });
          setAddressResults([]);
          setShowResults(false);
        }
      }

      saveSearchHistory(searchData, data);
    } catch (error) {
      // console.error("Error fetching addresses:", error);
      setAddressResults([]);
      setBoundaryData([]);
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };
  const toggleView = (view: "grid" | "map") => {
    if (view === "grid") {
      setViewAsGrid(true);
      ReactGA.event({
        category: "Home",
        action: "Toggle View",
        label: "Grid",
      });
    } else {
      setViewAsGrid(false);
      ReactGA.event({
        category: "Home",
        action: "Toggle View",
        label: "Map",
      });
    }
  };
  const formatPamCode = (code: string) => {
    if (!/^\d+$/.test(code)) {
      return code;
    }

    if (code.length <= 6) return code;

    if (code.length > 6 && code.length <= 10) {
      return code.slice(0, 6) + "-" + code.slice(6);
    }

    return code.slice(0, 6) + "-" + code.slice(6, 10) + "-" + code.slice(10);
  };


  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('Text');
    const allowed = pastedData.replace(/[^a-zA-Z0-9- ]/g, '');
    setSearchData(allowed);

    ReactGA.event({
      category: "Home",
      action: "Search Paste",
      label: allowed,
    });
  };


  useEffect(() => {
    const storedUserName = localStorage.getItem('userName');
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, []);

  const fetchAndHandleUserProfile = async () => {
    try {
      const data = await getUserProfile(t);
      setUserProfile(data);
      setUserName(data.userName);
      updateUserName(data.userName);
      navigate('/profile', {
        state: {
          userName: data.userName,
          email: data.email,
          phoneNumber: data.phoneNumber,
        },
      });
    } catch (error) {
      toast.error(t("sessionExpired"));
      navigate('/home');
    }
  };



  const closeProfileModal = () => {
    setIsProfileModalOpen(false);
  };
  const handleUpdateClick = () => {
    if (userProfile) {
      navigate("/", { state: { userProfile } });

    }
  };



  return (
    <div className="bg-slate-100 flex flex-col min-h-screen select-none">
      <ToastContainer position="top-right" autoClose={1000} hideProgressBar />
      <Header userName={userName} fetchUserProfile={fetchAndHandleUserProfile} handleLogout={handleLogout} />


      <div className="container mx-auto px-4 flex flex-col flex-grow">
        <div className="bg-indigo-100 p-6 rounded-md shadow-sm relative mt-6 select-none w-full">
          <div className="flex flex-col lg:flex-row lg:space-x-4 justify-end items-end">

            <div ref={searchContainerRef} className="relative rounded-md flex w-full lg:w-auto">
              <form onSubmit={handleFormSubmit}>

                <input
                  type="text"
                  maxLength={16}
                  placeholder={t("SearchPamcodeHere")}
                  className="h-12 pl-4 pr-3 rounded-l-md focus:outline-none border-none placeholder-gray-500 w-full sm:w-[320px]"
                  value={searchData}
                  onChange={handleInputChange}
                  onFocus={handleSearchFocus}
                  onPaste={handlePaste}
                />
              </form>

              <button
                className="h-12 px-5 bg-blue-600 text-white text-sm rounded-r-md flex items-center justify-center"
                onClick={handleSearchClick}
              >
                {loading ? (
                  <ReactLoading type="spin" color="#fff" height={24} width={24} />
                ) : (
                  <svg
                    className="w-5 h-5 mr-2"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </button>


              {/* ============================================================
    PLACE SUGGESTIONS FROM NOMINATIM
============================================================ */}
              {placeSuggestions.length > 0 && (
                <ul
                  className="absolute top-10 bg-white border rounded-lg shadow-lg w-full mt-2 max-h-60 overflow-y-auto"
                  style={{
                    zIndex: 2000,
                    borderColor: '#ddd'
                  }}
                >
                  {placeSuggestions.map((suggestion, index) => (
                    <li
                      key={`place-${index}`}
                      className="p-3 cursor-pointer text-black border-b border-gray-200 hover:bg-blue-100"
                      onClick={() => handlePlaceSuggestionClick(suggestion)}
                    >
                      <div className="flex items-center">

                        <img
                          src={LocationIcon}
                          alt="Location"
                          className="w-5 h-5 mr-2"
                        />

                        <div className="flex flex-col min-w-0">

                          <span className="text-sm font-medium truncate">
                            {suggestion.name ||
                              suggestion.display_name?.split(',')[0]}
                          </span>

                          <span className="text-xs text-gray-500 truncate">
                            {suggestion.display_name}
                          </span>

                        </div>

                      </div>
                    </li>
                  ))}
                </ul>
              )}


              {/* ============================================================
    EXISTING PAM / HISTORY SUGGESTIONS
============================================================ */}
              {!(searchData[3] === '-' && searchData[7] === '-') &&
                suggestions.length > 0 && (
                  <ul
                    className="absolute top-10 bg-white border rounded-lg shadow-lg w-full mt-2 max-h-60 overflow-y-auto"
                    style={{
                      zIndex: 1999,
                      borderColor: '#ddd'
                    }}
                  >
                    {suggestions.map((suggestion, index) => {

                      /*
                       * ======================================================
                       * SEARCH HISTORY
                       * ======================================================
                       */
                      if (suggestion.type === 'history') {

                        const normalizedQuery = suggestion.query;

                        return (
                          <li
                            key={`history-${index}`}
                            className="p-2 flex items-center cursor-pointer text-black text-lg border-b border-gray-200 hover:bg-blue-100"
                            onClick={() =>
                              handleRecentSearchClick(normalizedQuery)
                            }
                          >
                            <img
                              src={History}
                              className="w-8 h-8 mr-2"
                              alt="History"
                            />

                            {formatPamCode(suggestion.query)}
                          </li>
                        );
                      }


                      /*
                       * ======================================================
                       * EXISTING PAM SUGGESTION
                       * ======================================================
                       */
                      return (
                        <li
                          key={`pam-${index}`}
                          className="p-2 flex items-center justify-between cursor-pointer text-black text-lg border-b border-gray-200 hover:bg-blue-100"
                          onClick={() => {

                            if (suggestion.pamCode) {

                              handleAddressClick(
                                suggestion.pamCode,
                                suggestion
                              );

                              setSearchData(
                                formatPamCode(
                                  suggestion.pamCode.replace(/-/g, '')
                                )
                              );

                            }

                            setSuggestions([]);
                          }}
                        >

                          <span>
                            {suggestion.displayText ||
                              JSON.stringify(suggestion)}
                          </span>

                          <img
                            src={LocationIcon}
                            alt="Map Icon"
                            className="w-6 h-6 ml-2 cursor-pointer"
                            onClick={(e) => {

                              e.stopPropagation();

                              handleLocationIconClick(
                                suggestion.latitude,
                                suggestion.longitude
                              );

                            }}
                          />

                        </li>
                      );
                    })}
                  </ul>
                )}
            </div>
          </div>

          {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}

          <div className="hidden lg:block absolute left-4 bottom-0">
            <img src={Search} alt="Illustration" className="h-20" />
          </div>
        </div>


        <main className="w-full flex-grow">
          <div>
            {showResults && !isPolygonView && (
              <div className="flex gap-4 mt-3">
                {(validAddresses.length > 0 && validAddresses.some(addr => addr.addressLine3)) && (
                  <div className="flex rounded-lg shadow-shadow1 sm:w-auto w-full bg-white border border-white">
                    <ul
                      className="relative flex w-full flex-wrap px-2.5 py-3.5 list-none rounded-md bg-white"
                      data-tabs="tabs"
                      role="list"
                    >
                      <li className="z-30 flex-auto text-center mr-2">
                        <a
                          className={`z-30 flex items-center justify-center w-full px-4 py-2 text-sm mb-0 transition-all ease-in-out border border-white rounded-md cursor-pointer ${!viewAsGrid ? 'border-white text-blue-500 bg-[#D6DFFE]' : 'text-slate-600 bg-inherit'}`}
                          role="tab"
                          aria-selected={!viewAsGrid}
                          onClick={() => toggleView("map")}
                        >
                          <img src={MapIcon} alt="View on Map" className="w-4 h-4 mr-1.5" />
                          <span className="ml-1">{t("map")}</span>
                        </a>
                      </li>

                      {showResults && !isPolygonView && validAddresses.length > 0 && (
                        <li className="z-30 flex-auto text-center">
                          <a
                            className={`z-30 flex items-center justify-center w-full px-4 py-2 text-sm mb-0 transition-all ease-in-out border border-white rounded-lg cursor-pointer ${viewAsGrid ? 'border-white text-blue-500 bg-[#D6DFFE]' : 'text-slate-600 bg-inherit'}`}
                            role="tab"
                            aria-selected={viewAsGrid}
                            onClick={() => toggleView("grid")}
                          >
                            <img src={GridIcon} alt="View as Grid" className="w-4 h-4 mr-1.5" />
                            <span className="ml-1">{t("details")}</span>
                          </a>
                        </li>
                      )}
                    </ul>

                  </div>
                )}
              </div>
            )}

            {!showResults && (
              <div className="p-3 mx-auto mt-3 bg-white rounded-lg h-500px w-full">

                <div className="w-full overflow-hidden" style={{ height: 'calc(100vh - (300px))' }}>
                  {isPolygonView ? (
                    <PolygonMapComponent />
                  ) : (
                    <MapComponent />
                  )}

                </div>
              </div>

            )}

            {showResults && (
              <div className="mt-3">
                {viewAsGrid && !isPolygonView && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 rounded-lg bg-white shadow-shadow1 w-auto p-4 mb-14 ">
                    {addressResults.length > 0 ? (
                      addressResults.map((address, index) => {
                        const pamCode = address.pinCode + address.blockCode + address.addressCode;
                        return (

                          <div
                            key={address.id || index}
                            className="relative border p-4 rounded-md shadow-sm cursor-pointer hover:border-blue-500 transition-colors"
                            onClick={(e) => {
                              const target = e.target as HTMLElement;
                              if (!target.closest('button')) {
                                handleAddressClickDetails(address);
                              }
                            }}
                          >
                            <div className='grid sm:grid-cols-2 gap-3 mb-3'>
                              <div className="text-sm sm:text-base lg:text-lg font-bold text-gray-800 flex items-center gap-2 sm:order-1 order-2">
                                {address.addressType?.toLowerCase() === 'office' && (
                                  <>
                                    <img
                                      src={OfficeIcon}
                                      alt="Office Icon"
                                      className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0"
                                    />
                                    <span>{t("office")}</span>
                                  </>
                                )}

                                {address.addressType?.toLowerCase() === 'home' && (
                                  <>
                                    <img
                                      src={HomeIcon}
                                      alt="Home Icon"
                                      className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0"
                                    />
                                    <span>{t("home")}</span>
                                  </>
                                )}
                                {address.addressType?.toLowerCase() === 'other' && (
                                  <>
                                    <img
                                      src={OtherIcon}
                                      alt="Other Icon"
                                      className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0"
                                    />
                                    <span>{t("other")}</span>
                                  </>
                                )}
                                {!['office', 'home', 'other'].includes(address.addressType?.toLowerCase() || '') && (
                                  <>
                                    <img
                                      src={OtherIcon}
                                      alt="Custom Type Icon"
                                      className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0"
                                    />
                                    <span>{address.addressType}</span>
                                  </>
                                )}
                              </div>
                              <div className="grid grid-cols-3 sm:order-2 items-start">
                                <div className="flex gap-2 sm:gap-3 col-span-3 order-2 justify-end">
                                  <button
                                    title="Favourites"
                                    className="p-2 border border-[#D6DFFE] bg-red-50 rounded-md hover:bg-[#c4d4fc] focus:outline-none flex-shrink-0 transition-colors"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      HeartClick(Number(address.id), address.isFavourite);
                                    }}
                                  >
                                    <img
                                      src={address.isFavourite ? FavouriteTrue : FavouriteFalse}
                                      alt="Favourites"
                                      className="w-4 h-4 sm:w-5 sm:h-5"
                                    />
                                  </button>
                                  <button
                                    title="Location"
                                    className="p-2 border border-[#D6DFFE] bg-gray-100 rounded-md hover:bg-[#c4d4fc] focus:outline-none flex-shrink-0 transition-colors"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleLocationIconClick(address.latitude, address.longitude);
                                    }}
                                  >
                                    <img
                                      src={LocationIcon}
                                      alt="Location"
                                      className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div className="space-y-2">
                              <p className="text-xs sm:text-sm font-semibold text-gray-700 mt-2 break-words select-text"
                              >
                                {address.addressLine1}
                              </p>

                              <p
                                className="text-xs sm:text-sm text-[#61677D] break-words mb-2 select-text"
                              >
                                {address.addressLine2}, {address.addressLine3}, {address.postOfficeName} P.O.
                              </p>

                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-2 w-full mb-2 mt-3 sm:mt-0">
                                <label htmlFor="pamCode" className="text-xs sm:text-sm font-medium whitespace-nowrap w-full sm:w-24">
                                  {t("pamCode")}:
                                </label>
                                <div className="relative flex-1">
                                  <input
                                    type="text"
                                    className="w-full p-1.5 sm:p-2 pr-8 sm:pr-10 border rounded-md text-xs sm:text-sm"
                                    value={pamCode ? formatPamCode(pamCode) : "N/A"}
                                    readOnly
                                    onClick={(e) => e.stopPropagation()}
                                    onMouseDown={(e) => e.stopPropagation()}
                                  />
                                  <button
                                    className="absolute right-1 sm:right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-blue-500"
                                    onClick={() => handleCopy(pamCode ? formatPamCode(pamCode) : "N/A", "pamCode")}
                                  >
                                    {copiedField?.type === "pamCode" && copiedField.value === (pamCode ? formatPamCode(pamCode) : "N/A") ? (
                                      <img src={CheckIcon} alt="Copied" className="w-3 h-3 sm:w-4 sm:h-4" />
                                    ) : (
                                      <img src={CopyIcon} alt="Copy" className="w-3 h-3 sm:w-4 sm:h-4" />
                                    )}
                                  </button>
                                </div>
                              </div>

                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-2 w-full mb-2 mt-2">
                                <label htmlFor="digipin" className="text-xs sm:text-sm font-medium whitespace-nowrap w-full sm:w-24">
                                  {t("digiPin")}:
                                </label>
                                <div className="relative flex-1">
                                  <input type="text" className="w-full p-1.5 sm:p-2 pr-8 sm:pr-10 border rounded-md text-xs sm:text-sm"
                                    value={address.digiPin || "N/A"}
                                    readOnly
                                    onClick={(e) => e.stopPropagation()}
                                    onMouseDown={(e) => e.stopPropagation()} />

                                  <button className="absolute right-1 sm:right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-blue-500" onClick={() => handleCopy(address.digiPin || "N/A", "digiPin")}>
                                    {copiedField?.type === "digiPin" && copiedField.value === (address.digiPin || "N/A") ? (
                                      <img src={CheckIcon} alt="Copied" className="w-3 h-3 sm:w-4 sm:h-4" />
                                    ) : (
                                      <img src={CopyIcon} alt="Copy" className="w-3 h-3 sm:w-4 sm:h-4" />
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                        );
                      })
                    ) : (
                      <p className="text-gray-500">{t("noAddresses")}</p>
                    )}
                  </div>

                )}

                {!viewAsGrid && (
                  <div
                    className={`mt-3 bg-white p-3 rounded-md overflow-hidden`}
                    style={
                      isPolygonView
                        ? { height: 'calc(100vh - 280px)' }
                        : isPolygonBlockView
                          ? (addressResults.length > 0 && addressResults[0]?.addressLine3)
                            ? { height: 'calc(100vh - 360px)' }
                            : { height: 'calc(100vh - 290px)' }
                          : (addressResults.length > 0 && addressResults[0]?.addressLine1)
                            ? { height: 'calc(100vh - 360px)' }
                            : { height: 'calc(100vh - 280px)' }
                    }
                  >
                    {isPolygonView ? (
                      <PolygonMapComponent addresses={addressResults} boundaryData={boundaryData} />
                    ) : isPolygonBlockView ? (
                      <PolygonBlockMap addresses={addressResults} boundaryData={boundaryData as BoundaryData[]} />
                    ) : (
                      (searchData[3] === '-' && searchData[7] === '-' && searchData.length >= 12 && !addressResults[0]?.addressCode) ? (
                        <MapDigipin
                          addresses={addressResults}
                          boundaryData={boundaryData as BoundaryData[]}
                          markerLat={addressResults[0]?.latitude ? Number(addressResults[0].latitude) : undefined}
                          markerLng={addressResults[0]?.longitude ? Number(addressResults[0].longitude) : undefined}
                        />
                      ) : (
                        <MapComponent addresses={addressResults} boundaryData={boundaryData as BoundaryData[]} showLocateControl={false}>
                          {addressResults.length > 0 && (
                            <MapRecenter center={[Number(addressResults[0].latitude), Number(addressResults[0].longitude)]} />
                          )}
                        </MapComponent>
                      )
                    )}
                  </div>
                )}
              </div>
            )}



          </div>



        </main>

      </div >
      <footer className="w-full mt-4 sm:mt-auto px-4">
        <div className="container mx-auto">
          <div className="px-6 py-6 bg-white shadow-shadow1 rounded-md">
            <p className="text-center text-jetgrey text-sm">
              GET ME THERE © {year}
            </p>
          </div>
        </div>
      </footer>

    </div >
  );
};





export default Home;
